import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "back-icon__Svg",
  componentId: "sc-1m5zjrp-0"
})(["width:40px;height:40px;color:", ";"], p => p.theme.colors.primary500);
export var Back = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 40 40",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M14.1213203,20 L24.3743687,30.2530483 C24.9601551,30.8388348 24.9601551,31.7885822 24.3743687,32.3743687 C23.7885822,32.9601551 22.8388348,32.9601551 22.2530483,32.3743687 L10.9393398,21.0606602 C10.3535534,20.4748737 10.3535534,19.5251263 10.9393398,18.9393398 L22.2530483,7.62563133 C22.8388348,7.03984489 23.7885822,7.03984489 24.3743687,7.62563133 C24.9601551,8.21141777 24.9601551,9.16116524 24.3743687,9.74695167 L14.1213203,20 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "40",
    height: "40"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "40",
    height: "40"
  })));
};